module.exports = __webpack_public_path__ + "static/media/SWSCRC1-31.da5e5e25.mp3";